// extracted by mini-css-extract-plugin
module.exports = {"component":"loading_component__17ynA"};